import { z } from "zod";

/**
 * One page of a day-paged bookings list — the partner's submissions and the host's review
 * history: `offset` and `pageSize` both count board days, not rows.
 */
export const getPartnerBookingSubmissionsQuerySchema = z.object({
	offset: z.coerce.number().int().min(0).default(0),
	pageSize: z.coerce.number().int().positive().max(31).default(7),
});

export type GetPartnerBookingSubmissionsQuerySchema = z.infer<
	typeof getPartnerBookingSubmissionsQuerySchema
>;
